export default __webpack_public_path__ + "static/media/img_02.13e5c741.svg";